module.exports = {
  draftsList: 'List of Deactivations',
  closedList: 'Closed List',
  editImage: {
    title: 'Edit Image',
  },
  header: {
    titlePlayer: 'Player Profiles',
    titleCoach: 'Coach Profiles',
    buttonCreate: 'Create',
    buttonPublish: 'Publish',
    buttonUpdate: 'Update',
  },
  table: {
    title: {
      index: 'NO',
      show: 'Active',
      titlePlayer: 'PLAYER',
      titleCoach: 'TITLE',
      link: 'DEEP LINK TYPE',
      partner: 'PARTNER',
      status: 'STATUS',
      action: 'ACTION',
      country: 'COUNTRY',
    },
    tooltip: {
      edit: 'Edit',
      delete: 'Delete',
      inactive: 'InActive',
      active: 'Active',
      revert: 'Revert Image',
      upload: 'Upload Image',
    },
    popup: {
      title: 'Confirm',
      okBtn: 'Yes',
      cancelBtn: 'No',
      delete: 'Are you sure to delete this Coach Profile?',
      edit: 'Are you sure to edit this Coach Profile?',
      enable: 'Are you sure you want to enable this Coach Profile?',
      disable: 'Are you sure you want to disable this Coach Profile?',
      confirmPassword: 'Please input your password to confirm.',
      revert: 'Are you sure you want to revert the changes?',
    },
  },
  form: {
    image3x4: 'Please upload a 3x4 image',
    imageUpload: '*Upload an image',
    title: 'Coach Name',
    subTitle: 'Subtitle',
    countries: 'Countries',
    country: 'Country',
    btnUpdateCoachProfile: 'Update',
    btnCreateCoachProfile: 'Add',
    updateCoachProfile: 'Edit Coach',
    createCoachProfile: 'Create Coach',
    backgroundColor: 'Background Color',
    tag: 'Coach Tag',
    description: 'Coach Bio',
    logo: 'Logo',
    upload: 'Upload',
    drillTitle: 'Drill List Title',
  },
  validate: {
    titleBlank: 'Please input title!',
    drillTitleBlank: 'Please input drill list title!',
    tagBlank: 'Please input tag!',
    countryBlank: 'Please select country!',
    linkBlank: 'Please input a link!',
    imageBlank: 'Please input an image!',
    ctaBlank: 'Please input a CTA!',
    buttonList: 'Please input Button (All Coach Profile) text!',
    buttonDetail: 'Please input Button (Coach Profile Details) text!',
  },
  message: {
    error: {
      uploadImage: 'There was an error while uploading the image. Please try again',
      requireUpload: 'Please upload an image',
      updateProductEcomError: 'Failed to update ECOM product.',
    },
    success: {
      updateCoachProfile: 'Coach Profile successfully updated.',
      createCoachProfile: 'Coach Profile successfully added.',
      deleteCoachProfile: 'Coach Profile successfully deleted.',
      updateProductEcomSuccess: 'ECOM Product successfully updated.',
      revertPlayer: 'Image reverted to original.',
      uploadImageSuccess: 'Player image successfully uploaded.',
    },
  },
};
